import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  padding: 0 3rem;
`;
export const Container2 = styled.div`
  max-width: 1040px;

  margin: 0 auto;
  margin-bottom: 50px;

  display: grid;
  gap: 10px;
  grid-template-columns: repeat(auto-fit, minmax(226px, 1fr));
  grid-template-rows: repeat(1, 58px);

  @media screen and (max-width: 986px) {
    grid-template-rows: repeat(2, 58px);
  }
  @media screen and (max-width: 509px) {
    grid-template-rows: repeat(2, 40px);
  }
`;
export const Button = styled.button`
  border: #071242 solid 3px;
  border-radius: 15px;
  padding: 8px 20px;
  background: ${({ selected }) => (selected ? "#071242" : "#fff")};

  font-weight: bold;
  font-size: 12px;
  line-height: 1.05;
  color: ${({ selected }) => (selected ? "#fff" : "#071242")};

  @media screen and (max-width: 347px) {
    padding: 8px 15px;
  }
  @media screen and (max-width: 330px) {
    padding: 8px 10px;
  }
`;
